import { render, staticRenderFns } from "./procurement_search.vue?vue&type=template&id=107832d9&scoped=true&"
import script from "./procurement_search.vue?vue&type=script&lang=js&"
export * from "./procurement_search.vue?vue&type=script&lang=js&"
import style0 from "./procurement_search.vue?vue&type=style&index=0&id=107832d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107832d9",
  null
  
)

export default component.exports